import React from 'react';
import { ShieldIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-ink-950 pb-24 pt-12 sm:pb-12" data-id="element-37" data-mp="3gf94guwt048f">
      <div className="mx-auto max-w-4xl px-5 text-center" data-id="element-38" data-mp="3ggtwodvnbb34">
        <p className="flex items-center justify-center gap-2 font-display text-sm font-bold uppercase tracking-[0.18em] text-slate-400" data-id="element-39" data-mp="32oe11y52qfc8">
          <ShieldIcon className="h-4 w-4 text-shield-500" aria-hidden="true" data-id="element-40" data-mp="36pz9n7aks7gm" />
          Escudo Digital 2025
        </p>
        <p className="mt-4 text-xs leading-relaxed text-slate-500" data-id="element-41" data-mp="3ucxmluzhkx9s">
          Material educativo de seguridad digital. No está afiliado a WhatsApp, Meta, Mercado Pago ni
          a ninguna entidad bancaria.
        </p>
        <p className="mt-3 text-xs text-slate-600" data-id="element-42" data-mp="3qdf393nbcu92">
          © {new Date().getFullYear()} Escudo Digital. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}